import { render, staticRenderFns } from "./PrintingSpool.vue?vue&type=template&id=2b8c0418&"
import script from "./PrintingSpool.vue?vue&type=script&lang=js&"
export * from "./PrintingSpool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports